export const _PAYMENT_REQUEST = '_PAYMENT_REQUEST';

export const _GET_POINT = '_GET_POINT';

export const _CHARGING_POINT = '_CHARGING_POINT';

export const _GET_BILL_INFO = '_GET_BILL_INFO';

export const _GET_POINT_USAGE = '_GET_POINT_USAGE';
